import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseEditFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.93936 21.0606C2.58473 20.706 2.4308 20.1976 2.52915 19.7058L3.52915 14.7058C3.58723 14.4154 3.72996 14.1487 3.93936 13.9393L15.2323 2.64642C16.2086 1.67011 17.7915 1.67011 18.7678 2.64642L21.3536 5.2322C22.3299 6.20851 22.3299 7.79143 21.3536 8.76774L10.0607 20.0606C9.85128 20.27 9.58459 20.4128 9.2942 20.4708L4.2942 21.4708C3.80241 21.5692 3.294 21.4153 2.93936 21.0606ZM15.4697 5.46964C15.7626 5.17675 16.2375 5.17675 16.5304 5.46964L18.5304 7.46964C18.8233 7.76253 18.8233 8.23741 18.5304 8.5303C18.2375 8.82319 17.7626 8.82319 17.4697 8.5303L15.4697 6.5303C15.1768 6.23741 15.1768 5.76253 15.4697 5.46964ZM5.4697 15.4696C5.76259 15.1767 6.23747 15.1767 6.53036 15.4696L8.53036 17.4696C8.82325 17.7625 8.82325 18.2374 8.53036 18.5303C8.23747 18.8232 7.76259 18.8232 7.4697 18.5303L5.4697 16.5303C5.17681 16.2374 5.17681 15.7625 5.4697 15.4696Z"
        fill={color}
      />
    </svg>
  );
};
